import React from "react";

export default function Loading() {
  return (
    <div className="container mx-auto">
      <div className="flex items-center flex-col">
        <div className="w-11/12 h-60 my-7 bg-gray-200 rounded-lg animate-pulse"></div>
        <div className="w-32 h-4 bg-gray-200 rounded-full animate-pulse"></div>
        <div className="w-48 h-4 mt-2 bg-gray-200 rounded-full animate-pulse"></div>
      </div>
    </div>
  );
}
